import { useParams } from "react-router-dom";
import VehiculosRegistro from "./VehiculosRegistro";
import VehiculosClasificador from "./VehiculosClasificador";
import VehiculosCalculo from "./VehiculosCalculo";

const VehiculosPage = () => {
  const { submodulo } = useParams();

  if (submodulo === "registro") return <VehiculosRegistro />;
  if (submodulo === "clasificador") return <VehiculosClasificador />;
  if (submodulo === "calculo") return <VehiculosCalculo />;

  return null;
};

export default VehiculosPage;
